export default class Loader {
    constructor (el, loadingMessage = 'Loading...', errorElement = null) {
        this.el = el
        this.errorElement = errorElement
        this.loading = false
        this.loadingMessage = loadingMessage
        this.buttonInitialHTML = this.el.innerHTML
    }

    start (message = null) {
        this.loading = true
        this.loadingMessage = message ? message : this.loadingMessage

        this.el.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> ' + this.loadingMessage
        if(this.errorElement){
            const error = this.errorElement.querySelector('.form__error');
            if(error){
                error.remove();
            }
        }else{
            const maybeError = this.el.nextElementSibling
            if (maybeError && maybeError.classList.contains('form__error')) {
                maybeError.remove()
            }
        }
    }

    stop (message = null, preserveMessage = false) {
        this.loading = false

        if (message) {
            this.el.innerHTML = message
            if(!preserveMessage){
                setTimeout(() => {
                    this.el.innerHTML = this.buttonInitialHTML
                }, 1000)
            }
        } else {
            this.el.innerHTML = this.buttonInitialHTML
        }
    }

    error (message = null) {
        this.loading = false

        if (message) {
            if(this.errorElement){
                const error = document.createElement('div')
                error.classList.add('form__error')
                error.innerHTML = message
                this.errorElement.appendChild(error)
            }else{
                this.el.insertAdjacentHTML('afterend', '<div class="form__error">' + message + '</div>')
            }   
        }
        this.el.innerHTML = this.buttonInitialHTML
    }

    message(message = null) {
        this.el.innerHTML = this.loading ? '<i class="fas fa-circle-notch fa-spin"></i> ' + message : message
    }

    isLoading () {
        return this.loading
    }
}